import React, { useState } from 'react';
import Select from 'react-select';

// 全モデルの選択肢。デモ画面など「扱えるモデルが限られる場面」では
// options prop でこのリストの部分集合を渡して絞り込む。
export const MODEL_SELECT_OPTIONS = [
    { value: 'plate1', label: 'plate1' },
    { value: 'model1_1', label: 'model1_1/皿を大きく描いてしまう誤り(形状変更)' },
    { value: 'model', label: 'model/正解のモデル' },
    { value: 'model1', label: 'model1/皿を丸く描いてしまう誤り' },
    { value: 'model2', label: 'model2/皿を大きく描いてしまう誤り' },
    { value: 'model3', label: 'model3/グラスの太さの誤り' },
    { value: 'model4', label: 'model4/グラスの上部を丸く描いてしまう誤り/断面間の誤り' },
    { value: 'model5', label: 'model5/グラスの横幅の関係誤り' },
    { value: 'model6', label: 'model6/皿のリムの広さの誤り' },
    { value: 'model7', label: 'model7/グラスの傾きの誤り' },
    { value: 'model8', label: 'model8/皿の深さの誤り' },
    { value: 'cube', label: 'cube/立方体のモデル（テスト用）' },
    { value: 'cube_model1', label: 'cube_model1/立方体:幅の発散遠近（上面の後退辺が奥へ開く）' },
    { value: 'cube_model2', label: 'cube_model2/立方体:高さの発散遠近（側面が奥へ開く）' },
    { value: 'cube_model3', label: 'cube_model3/立方体:上面左奥垂直' },
    { value: 'cube_model4', label: 'cube_model4/立方体:下面右下出っ張り' },
    { value: 'cube_model5', label: 'cube_model5/立方体:上面が開く誤り（視点変更ガイド対応）' },
    { value: 'cube_model0', label: 'cube_model0/立方体モチーフ' },
];

function ModelSelecter({ errorGlbPath, setErrorGlbPath, options = MODEL_SELECT_OPTIONS }) {
    const [selectedOption, setSelectedOption] = useState(null);

    const handleModelChange = (selectedOption) => {
        setSelectedOption(selectedOption);
    };

    const handleLoadModel = () => {
        if (selectedOption) {
            setErrorGlbPath(selectedOption.value);
        }
    };

    return (
        <div>
            <Select
                value={selectedOption}
                onChange={handleModelChange}
                options={options}
                placeholder="Select a model　　　　　　　　　"
                aria-label="モデル選択"
            />
            <button onClick={handleLoadModel} className="btn btn--small">Load Model</button>
        </div>
    );
}

export default ModelSelecter;